import { compiler } from 'markdown-to-jsx'
import { renderToString } from 'react-dom/server'

import { configuration } from 'components/ReactMarkdown'

export const getHtmlStringFromMarkdown = (markdown: string, messageId?: string) =>
  renderToString(compiler(markdown, configuration({ isHtmlOnly: true, messageId })))
